var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyclassAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008EC1;}\n\t.st1{fill:#9CCDE2;}\n\t.st2{fill:#C1E4EF;}\n\t.st3{fill:#A12646;}\n\t.st4{fill:#7F1D3C;}\n\t.st5{fill:#5DB18B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98,84.8l16.2-16.5l-14.1-14.4c-0.9-0.9-1.2-2.2-0.9-3.4c0.4-1.2,1.4-2.1,2.7-2.4l24.4-5 c1.1-0.2,2.3,0.1,3.2,1l33.6,33.6c0.7,0.7,1,1.5,1,2.5c0,0.9-0.4,1.8-1,2.5l-9.1,9.1c0,0,0,0,0,0c-7.2,6.1-12.5,0.4-12.5,0.4 l-11.5-13.1l-3.3,3.3c-16.4,13.1-29.5,3.3-29.5,3.3l0,0L98,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.7,84.4l-18.9,19l0.1,0.1l-1.4,1.4l-2.7,2.5l-8.3,8.4l0.1,0.1l-0.8,0.8l-2.9,2.8l-34.1,34l0.1,0l0,0 c-1.8,1.8-4.1,2.7-6.5,2.7c-2.4,0-4.6-0.8-6.2-2.4c6.5-4.7,41.9-31.8,38.7-58.5v0l6.5-6.6l-0.1-0.1l1.1-1.2l0,0l2-1.9l0,0 c0,0,13.1,9.8,29.5-3.3l3.3-3.3l11.5,13.1c0,0,5.3,5.7,12.5-0.4l-5.6,5.6c-1.3,1.3-3.6,1.3-4.9,0L130.7,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.8,95.2c3.2,26.7-32.2,53.7-38.7,58.5c-0.1-0.1-0.2-0.1-0.2-0.2l-2.9-2.9c-1.8-1.8-2.7-4.1-2.7-6.5 c0-2.6,0.9-4.8,2.7-6.4l0.1-0.1l21.9-22.1h-0.1L87.8,95.2z"
  })), /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.9,64.1l-0.1,0c-1.2,1.2-2.9,1.9-4.6,1.9c-1.7,0-3.3-0.7-4.6-1.9L48.5,60c-1.1-1.1-2.6-1.4-4-1 c-0.5,0.1-0.9,0.4-1.2,0.7c-0.3,1.2-0.4,2.5-0.4,3.9c0,9.6,7.8,17.4,17.4,17.4c5.1,0,9.7-2.2,12.8-5.6L61.9,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.8,63.9L61.7,64l0.1,0l11.3,11.3c2.8-3.1,4.6-7.2,4.6-11.8c0-9.6-7.8-17.4-17.4-17.4 c-1.1,0-2.2,0.1-3.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.5,1.4-0.1,2.9,1,4l4.1,4.1c1.2,1.2,1.9,2.8,1.9,4.5 C63.7,61.1,63,62.7,61.8,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.9,124.1c-3.1,3.2-5.1,7.5-5.1,12.3c0,9.6,7.8,17.4,17.4,17.4c1,0,2.1-0.1,3.1-0.3 c0.4-0.4,0.6-0.9,0.8-1.4c0.5-1.4,0.1-2.9-1-4l-4.3-4.3c-1.2-1.2-1.9-2.8-1.9-4.5c0-1.6,0.7-3.2,1.8-4.4l-0.1-0.1L121.9,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.3,81c-9.6,0-17.4-7.8-17.4-17.4c0-1.3,0.1-2.6,0.4-3.9c-0.7,0.6-1.3,1.4-1.4,2.5 c-1,6.9,1.3,13.8,6,18.6c5.5,5.6,13.4,7.6,21,5.5l1.5-0.4l4.9,4.9h0l30,29.3l2,2.1l0,0l4.1,4.1l-0.4,1.5c-2.1,7.6,0,15.4,5.6,21 c3.9,4,9.3,6.2,15.3,6.2c0.9,0,2-0.1,3.1-0.3c0.9-0.2,1.7-0.6,2.3-1.2c-1,0.2-2,0.3-3.1,0.3c-9.6,0-17.4-7.8-17.4-17.4 c0-4.8,2-9.2,5.1-12.3L73.1,75.3C69.9,78.8,65.4,81,60.3,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.6,134.8L132.6,134.8c0.1,0,0.1,0,0.1,0l0.1-0.1c1.2-1.2,2.9-1.9,4.6-1.9s3.3,0.7,4.6,1.9l4.3,4.3 c1,1.1,2.4,1.4,3.9,0.9c0.4-0.1,0.8-0.3,1.2-0.6c0.2-0.9,0.2-1.9,0.2-2.8c0-9.6-7.8-17.4-17.4-17.4c-4.8,0-9.2,2-12.3,5.1 L132.6,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.6,136.4c0,1-0.1,1.9-0.2,2.8c0.8-0.6,1.4-1.5,1.5-2.6c1-6.7-1.2-13.3-6-18c-5.4-5.4-13.4-7.6-20.7-5.7 l-1.5,0.4L112,100.7l-3.9-3.9l-0.1,0.1l-9.8-9.8l-4-4l-0.1,0.1L83.4,72.4l0.4-1.5c1.9-7.5-0.2-15.2-5.7-20.7 c-4.7-4.7-11.3-6.9-18-6c-1.4,0.2-2.6,1-3.1,2.2c1.1-0.2,2.2-0.3,3.3-0.3c9.6,0,17.4,7.8,17.4,17.4c0,4.5-1.7,8.7-4.6,11.8 l48.8,48.8c3.2-3.1,7.5-5.1,12.3-5.1C143.8,119,151.6,126.8,151.6,136.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyclassAdmin);
export default __webpack_public_path__ + "static/media/myclass_admin.699bfd7c2b40cd900a4d8575e808452b.svg";
export { ForwardRef as ReactComponent };